import _ from 'lodash'
import { COMMA } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import fetchListingInfoProposal from '../request/fetchListingInfoProposal'
import fetchBatchListings from '../request/fetchBatchListings'
import fetchBatchProposals from '../request/fetchBatchProposals'
import useOnInit from './useOnInit'

// 進入檢視頁時發出請求
// get updateListing proposal > get listing + get proposal(取得子單狀態與執行時間)
// updateListing proposal 的 subProposals 只提供 type & id 所以子提案需要另外發請求
const useUpdateListingProposalOnOverviewInit = (props, params, isOverviewPage, beforeInit, afterInit) => {
  const {
    actions
  } = props

  useOnInit(() => {
    const getBatchProposals = async () => {
      beforeInit && beforeInit()
      const [error, proposal = {}] = await fetchListingInfoProposal(actions, params.proposal)
      if (error) {
        afterInit(error)
        return
      }

      const listingId = _.get(proposal, 'listing.id')
      // 查無提案、查到提案但是沒有賣場
      if (_.isUndefined(listingId)) {
        afterInit(null, proposal)
        return
      }

      const listingsParams = {
        id: `${listingId}`,
        ..._.get(params, 'listing', {})
      }
      const proposalsParams = _.flow(
        () => _.get(proposal, 'subProposals', []),
        subProposals => _.map(subProposals, 'id'),
        ids => ({ id: _.join(ids, COMMA) })
      )()
      const [
        [listingsError, listings = []],
        [subProposalsError, subProposals = []]
      ] = await Promise.all([
        fetchBatchListings(actions, listingsParams),
        fetchBatchProposals(actions, proposalsParams)
      ])
      const requestError = listingsError || subProposalsError
      if (requestError) {
        afterInit(requestError)
        return
      }

      const subProposalMapByType = _.keyBy(subProposals, 'type')
      afterInit(null, proposal, _.first(listings), subProposalMapByType)
    }
    isOverviewPage && getBatchProposals()
  })
}

export default useUpdateListingProposalOnOverviewInit
